import { ValidateOtpRequestDto, ValidateOtpResponseDto } from "../../interfaces/ExtermalUserDtos/ExternalUsersDtos";
import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";

export const ValidateOtpForExternalUserAsync = async (
    ticketId: string,
    otp: string,
): Promise<ApiResponse<ValidateOtpResponseDto>> => {
    try {
        const payload : ValidateOtpRequestDto = {
            ticketId: ticketId,
            otp: otp
        }
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/video/validate-otp`
        // Adjust the base URL if needed
        const response = await fetch(apiUrl,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload)
            }
        );
        return await response.json();
    } catch (error) {
        throw error;
    }
}